/** Registration offer code purposes (settings/offers.codes). */
export const OFFER_CODE_TYPES = {
  PROOF_OF_PURCHASE: 'proof_of_purchase',
  DISCOUNT: 'discount',
};

export const OFFER_CODE_TYPE_OPTIONS = [
  {
    value: OFFER_CODE_TYPES.PROOF_OF_PURCHASE,
    label: 'Proof of purchase',
    shortLabel: 'Proof of purchase',
    description:
      'Partner has already been paid offline. School enters this code to unlock registration; portal opens without Stripe. Finance confirms settlement in the registry.',
    gateway: 'external',
  },
  {
    value: OFFER_CODE_TYPES.DISCOUNT,
    label: 'Discount code',
    shortLabel: 'Discount',
    description:
      'Reduced or fixed fee via normal checkout. School pays through Stripe (card) or requests an invoice at the code price.',
    gateway: 'stripe',
  },
];

export function resolveOfferCodeType(entry) {
  if (entry?.codeType === OFFER_CODE_TYPES.PROOF_OF_PURCHASE) {
    return OFFER_CODE_TYPES.PROOF_OF_PURCHASE;
  }
  if (entry?.codeType === OFFER_CODE_TYPES.DISCOUNT) {
    return OFFER_CODE_TYPES.DISCOUNT;
  }
  return entry?.requirePaymentGateway === false
    ? OFFER_CODE_TYPES.PROOF_OF_PURCHASE
    : OFFER_CODE_TYPES.DISCOUNT;
}

export function requirePaymentGatewayForCodeType(codeType) {
  return codeType !== OFFER_CODE_TYPES.PROOF_OF_PURCHASE;
}

export function offerCodeTypeLabel(codeType) {
  const opt = OFFER_CODE_TYPE_OPTIONS.find((o) => o.value === codeType);
  return opt?.shortLabel || 'Discount';
}

export function isSingleUseOffer(entry) {
  return entry?.singleUse === true;
}

export function offerRedemptionLabel(entry) {
  if (!entry?.redeemedSchoolName) return null;
  return String(entry.redeemedSchoolName).trim() || null;
}

const OFFER_REDEMPTION_PRESERVE_KEYS = [
  'redeemedBySchoolId',
  'redeemedSchoolName',
  'redeemedAt',
  'redeemedLevel',
  'reservedBySchoolId',
  'reservedAt',
];

export function preserveOfferRedemptionFields(nextPayload, existingEntry) {
  if (!existingEntry || typeof existingEntry !== 'object') return nextPayload;
  const merged = { ...nextPayload };
  OFFER_REDEMPTION_PRESERVE_KEYS.forEach((key) => {
    if (existingEntry[key] != null) merged[key] = existingEntry[key];
  });
  return merged;
}

export function buildOfferCodePayload(draft) {
  const codeType = resolveOfferCodeType(draft);
  const payload = {
    code: draft.code,
    label: draft.label || '',
    active: draft.active !== false,
    codeType,
    requirePaymentGateway: requirePaymentGatewayForCodeType(codeType),
    amounts: draft.amounts,
  };
  if (draft.singleUse === true) {
    payload.singleUse = true;
  }
  return payload;
}
